export enum CTMSAPI {
  'CREATE_MILESTONE' = 'CREATE_MILESTONE',
  'GET_IP_RELEASE_DOCS' = 'GET_IP_RELEASE_DOCS',
  'GET_IP_RELEASE_STATUS' = 'GET_IP_RELEASE_STATUS',
  'CREATE_SIV_CHECKLIST' = 'CREATE_SIV_CHECKLIST',
  'GET_ALL_SITE_PERSONNEL' = 'GET_ALL_SITE_PERSONNEL',
  'GET_REQUEST_ACCESS_PERSONNEL' = 'GET_REQUEST_ACCESS_PERSONNEL',
  'CREATE_SIV_REPORT' = 'CREATE_SIV_REPORT',
  'CREATE_BUDGET' = 'CREATE_BUDGET',
  'UPDATE_BUDGET' = 'UPDATE_BUDGET',
  'UPDATE_SIV_CHECKLIST' = 'UPDATE_SIV_CHECKLIST',
  'CREATE_STUDY' = 'CREATE_STUDY',
  'UPDATE_IP_SUPPLY_ORDER' = 'UPDATE_IP_SUPPLY_ORDER',
  'CREATE_IP_SUPPLY_ORDER_FROM_API' = 'CREATE_IP_SUPPLY_ORDER_FROM_API',
  'UPDATE_MILESTONE' = 'UPDATE_MILESTONE',
  'GET_IP_SUPPLY_ORDER' = 'GET_IP_SUPPLY_ORDER',
  'UPDATE_SQ_REPORT' = 'UPDATE_SQ_REPORT',
  'DELETE_STUDY_PERSON' = 'DELETE_STUDY_PERSON',
  'GET_MILESTONE' = 'GET_MILESTONE',
  'UPDATE_SIV_QUERY' = 'UPDATE_SIV_QUERY',
  'GET_SIV_CHECKLIST' = 'GET_SIV_CHECKLIST',
  'GET_SITE_COUNTRY' = 'GET_SITE_COUNTRY',
  'UPDATE_PERSON_FICS_TRAINING' = 'UPDATE_PERSON_FICS_TRAINING',
  'GET_SQ_REPORT' = 'GET_SQ_REPORT',
  'GET_STUDY_PERSON_DETAIL' = 'GET_STUDY_PERSON_DETAIL',
  'UPDATE_SITE_IDENTIFIED_FOR_STUDY' = 'UPDATE_SITE_IDENTIFIED_FOR_STUDY',
  'CREATE_IP_SUPPLY_ORDER' = 'CREATE_IP_SUPPLY_ORDER',
  'GET_AUDIT_TRIAL' = 'GET_AUDIT_TRIAL',
  'GET_STUDY_COUNTRY' = 'GET_STUDY_COUNTRY',
  'GET_ALL_CODELIST_ITEM' = 'GET_ALL_CODELIST_ITEM',
  'GET_CODELIST_ITEM' = 'GET_CODELIST_ITEM',
  'UPDATE_ESSENTIAL_DOC' = 'UPDATE_ESSENTIAL_DOC',
  'CREATE_SIV_QUERY_RESPONSE' = 'CREATE_SIV_QUERY_RESPONSE',
  'CREATE_STARTUP_FEASIBILITY' = 'CREATE_STARTUP_FEASIBILITY',
  'CREATE_SIV_QUERY' = 'CREATE_SIV_QUERY',
  'GET_AUDIT_TRIAL_FILTERS' = 'GET_AUDIT_TRIAL_FILTERS',
  'UPDATE_PERSON_FICS_TRAIN_REQ' = 'UPDATE_PERSON_FICS_TRAIN_REQ',
  'GET_SITE_STUDY_PERSONNEL_DETAILS' = 'UPDATE_PERSON_FICS_TRAIN_REQ',
  'GET_MAJOR_MILESTONE_SUMMARY' = 'GET_MAJOR_MILESTONE_SUMMARY',
  'UPDATE_SQ_CHECKLIST' = 'UPDATE_SQ_CHECKLIST',
  'UPDATE_SIV_REPORT' = 'UPDATE_SIV_REPORT',
  'CREATE_FILEMASTER_FILE_UPLOAD' = 'CREATE_FILEMASTER_FILE_UPLOAD',
  'VIEW_SQ_CHECKLIST' = 'VIEW_SQ_CHECKLIST',
  'GET_ALL_SITE_PERSONNEL_LIST' = 'GET_ALL_SITE_PERSONNEL_LIST',
  'GET_MILESTONE_GANTT' = 'GET_MILESTONE_GANTT',
  'CREATE_SQ_REPORT' = 'CREATE_SQ_REPORT',
  'UPDATE_STARTUP_FEASIBILITY' = 'UPDATE_STARTUP_FEASIBILITY',
  'CREATE_IP_RELEASE' = 'CREATE_IP_RELEASE',
  'CREATE_STUDY_PERSON' = 'CREATE_STUDY_PERSON',
  'UPDATE_CODELIST_ITEM' = 'UPDATE_CODELIST_ITEM',
  'DELETE_SIV_QUERY' = 'DELETE_SIV_QUERY',
  'GET_MILESTONE_FILTERED' = 'GET_MILESTONE_FILTERED',
  'GET_ALL_MILESTONES' = 'GET_ALL_MILESTONES',
  'CREATE_REQUEST_ACCESS_PERSONNEL' = 'CREATE_REQUEST_ACCESS_PERSONNEL',
  'GET_ALL_STUDY_ID' = 'GET_ALL_STUDY_ID',
  'GET_SIV_QUERY_RESPONSE' = 'GET_SIV_QUERY_RESPONSE',
  'CREATE_SQ_CHECKLIST' = 'CREATE_SQ_CHECKLIST',
  'GET_STUDY' = 'GET_STUDY',
  'UPDATE_MILESTONE_BY_ID' = 'UPDATE_MILESTONE_BY_ID',
  'GET_ALL_STUDY_PERSON_DETAILS' = 'GET_ALL_STUDY_PERSON_DETAILS',
  'CREATE_CODELIST_ITEM' = 'CREATE_CODELIST_ITEM',
  'DELETE_FILEMASTER_FILE' = 'DELETE_FILEMASTER_FILE',
  'UPDATE_MILESTONE_STATUS' = 'UPDATE_MILESTONE_STATUS',
  'GET_ALL_ESSENTIAL_DOC' = 'GET_ALL_ESSENTIAL_DOC',
  'GET_FILEMASTER_FILE' = 'GET_FILEMASTER_FILE',
  'GET_IP_SUPPLY_ORDER_FROM_API' = 'GET_IP_SUPPLY_ORDER_FROM_API',
  'GET_STARTUP_FEASIBILITY' = 'GET_STARTUP_FEASIBILITY',
  'GET_BUDGET' = 'GET_BUDGET',
  'GET_SIV_REPORT' = 'GET_SIV_REPORT',
  'GET_SIV_QUERY' = 'GET_SIV_QUERY',
  'GET_SQ_QUERY' = 'GET_SQ_QUERY',

  //Conduct Permissions
  'VIEW_CONDUCT_MILESTONE_TRACKING' = 'VIEW_CONDUCT_MILESTONE_TRACKING',
  'VIEW_CONDUCT_SUMMARY' = 'VIEW_CONDUCT_SUMMARY',
  'VIEW_SUBJECT_TRACKING' = 'VIEW_SUBJECT_TRACKING',
  'VIEW_IMVCHECKLIST' = 'VIEW_IMVCHECKLIST',
  'UPDATE_IMVCHECKLIST' = 'UPDATE_IMVCHECKLIST',
  'VIEW_IMVREPORT' = 'VIEW_IMVREPORT',
  'UPDATE_IMVREPORT' = 'UPDATE_IMVREPORT',
  'VIEW_CONDUCT_ISSUESLOG' = 'VIEW_CONDUCT_ISSUESLOG',
  'UPDATE_ISSUE' = 'UPDATE_ISSUE',
  'UPDATE_ISSUE_ACTION' = 'UPDATE_ISSUE_ACTION',
  'UPDATE_ISSUE_DECISION' = 'UPDATE_ISSUE_DECISION',
  'UPDATE_OTHERS_ISSUE' = 'UPDATE_OTHERS_ISSUE',
  'DELETE_OTHERS_ISSUE' = 'DELETE_OTHERS_ISSUE',
  'GET_ALL_SITE_PROTOCOL_DEVIATIONS' = 'GET_ALL_SITE_PROTOCOL_DEVIATIONS',
  'GET_ALL_SPONSOR_PROTOCOL_DEVIATIONS' = 'GET_ALL_SPONSOR_PROTOCOL_DEVIATIONS',
  'CREATE_SITE_PROTOCOL_DEVIATION' = 'CREATE_SITE_PROTOCOL_DEVIATION',
  'CREATE_SPONSOR_PROTOCOL_DEVIATION' = 'CREATE_SPONSOR_PROTOCOL_DEVIATION',
  'UPDATE_SITE_PROTOCOL_DEVIATION' = 'UPDATE_SITE_PROTOCOL_DEVIATION',
  'UPDATE_SPONSOR_PROTOCOL_DEVIATION' = 'UPDATE_SPONSOR_PROTOCOL_DEVIATION',
  'DELETE_SITE_PROTOCOL_DEVIATION' = 'DELETE_SITE_PROTOCOL_DEVIATION',
  'DELETE_SPONSOR_PROTOCOL_DEVIATION' = 'DELETE_SPONSOR_PROTOCOL_DEVIATION',
  'UPDATE_OTHERS_SITE_PROTOCOL_DEVIATIONS' = 'UPDATE_OTHERS_SITE_PROTOCOL_DEVIATIONS',
  'UPDATE_OTHERS_SPONSOR_PROTOCOL_DEVIATIONS' = 'UPDATE_OTHERS_SPONSOR_PROTOCOL_DEVIATIONS',
  'DELETE_OTHERS_SITE_PROTOCOL_DEVIATIONS' = 'DELETE_OTHERS_SITE_PROTOCOL_DEVIATIONS',
  'DELETE_OTHERS_SPONSOR_PROTOCOL_DEVIATIONS' = 'DELETE_OTHERS_SPONSOR_PROTOCOL_DEVIATIONS',
  'UPDATE_SITE_PROTOCOL_DEVIATION_ACTION' = 'UPDATE_SITE_PROTOCOL_DEVIATION_ACTION',
  'UPDATE_SPONSOR_PROTOCOL_DEVIATION_DECISION' = 'UPDATE_SPONSOR_PROTOCOL_DEVIATION_DECISION',
  'UPLOAD_IMVCHECKLISTDOCUMENT' = 'UPLOAD_IMVCHECKLISTDOCUMENT',
  'DELETE_IMVCHECKLIST DOCUMENT' = 'DELETE_IMVCHECKLIST DOCUMENT',
  'CREATE_IMVFOLLOWUP' = 'UPDATE_MODIFY_IMVCFOLLOWUP',
  'SELECT_IMVCFOLLOWUP' = 'UPDATE_MODIFY_IMVCFOLLOWUP',
  'UPDATE_MODIFY_IMVCFOLLOWUP' = 'UPDATE_MODIFY_IMVCFOLLOWUP'
}

export enum CTMSUI {
  'UPDATE_SITE_MILESTONES' = 'UPDATE_SITE_MILESTONES',
  'USER_CREATION' = 'USER_CREATION',
  'VIEW_ESSENTIAL_DOCS' = 'VIEW_ESSENTIAL_DOCS',
  'UPDATE_IP_RELEASE' = 'UPDATE_IP_RELEASE',
  'VIEW_SITE_MILESTONES' = 'VIEW_SITE_MILESTONES',
  'UPDATE_SQ_CHECKLIST' = 'UPDATE_SQ_CHECKLIST',
  'VIEW_IP_MANAGEMENT' = 'VIEW_IP_MANAGEMENT',
  'UPDATE_FICS_TRAIN_REQ' = 'UPDATE_FICS_TRAIN_REQ',
  'UPDATE_ESSENTIAL_DOCS' = 'UPDATE_ESSENTIAL_DOCS',
  'UPDATE_STUDY_IDENTIFIED_FOR_SITE' = 'UPDATE_STUDY_IDENTIFIED_FOR_SITE',
  'UPDATE_SIV_REPORT' = 'UPDATE_SIV_REPORT',
  'GET_SQ_CHECKLIST' = 'GET_SQ_CHECKLIST',
  'UPDATE_SIV_CHECKLIST' = 'UPDATE_SIV_CHECKLIST',
  'EXPORT_MILESTONES' = 'EXPORT_MILESTONES',
  'UPDATE_IP_SPONSOR_USE_FIELDS' = 'UPDATE_IP_SPONSOR_USE_FIELDS',
  'UPDATE_IP_SUPPLY_ORDER' = 'UPDATE_IP_SUPPLY_ORDER',
  'UPDATE_SITE' = 'UPDATE_SITE',
  'CREATE_SITE_CONTACT' = 'CREATE_SITE_CONTACT',
  'UPDATE_STUDY_INFORMATION' = 'UPDATE_STUDY_INFORMATION',
  'UPDATE_SQ_REPORT' = 'UPDATE_SQ_REPORT',
  'GET_MILESTONE_DETAILS' = 'GET_MILESTONE_DETAILS',
  'UPDATE_SITE_PERSONNEL_DETAIL' = 'UPDATE_SITE_PERSONNEL_DETAIL',
  'VIEW_SITE_CONTACT_INFO' = 'VIEW_SITE_CONTACT_INFO',
  'VIEW_SQ_CHECKLIST' = 'VIEW_SQ_CHECKLIST',
  'MANAGE_SITE_MILESTONES' = 'MANAGE_SITE_MILESTONES',
  'PRINT_MILESTONES' = 'PRINT_MILESTONES',
  //'VIEW_SQ_REPORT' = 'VIEW_SQ_REPORT',
  'VIEW_STARTUP_SUMMARY' = 'VIEW_STARTUP_SUMMARY',
  'VIEW_START_UP_PACKET' = 'VIEW_START_UP_PACKET',
  'UPDATE_PROTOCOL' = 'GET_STARTUP_PACKET',
  'UPDATE_DOA' = 'UPDATE_DOA',
  'UPDATE_CONTRACT_BUDGET' = 'UPDATE_CONTRACT_BUDGET',
  'UPLOAD_CONTRACT_BUDGET_DOCS' = 'UPLOAD_CONTRACT_BUDGET_DOCS',
  'VIEW_SQ_REPORT' = 'VIEW_SQ_REPORT',
  'VIEW_SIV_REPORT' = 'VIEW_SIV_REPORT',
  'VIEW_SIV_CHECKLIST' = 'VIEW_SIV_CHECKLIST',
  'VIEW_SQ_CHECKLIST_PIL' = 'VIEW_SQ_CHECKLIST_PIL',
  'VIEW_STUDY_LOGS' = 'VIEW_STUDY_LOGS',
  'VIEW_SQ_REPORT_AFTER_SUBMIT' = 'VIEW_SQ_REPORT_AFTER_SUBMIT',
  'ACTIVATE_SITE_MILESTONE' = 'ACTIVATE_SITE_MILESTONE',
  'REACTIVATE_SITE_MILESTONE' = 'REACTIVATE_SITE_MILESTONE',
  'VIEW_STARTUP_STUDYREPORTS' = 'VIEW_STARTUP_STUDYREPORTS',
  'VIEW_STARTUP_TASKS' = 'VIEW_STARTUP_TASKS',
  'PUBLISHVIEW_SIQUALIFI_CONFIRMATIONLETTER' = 'PUBLISHVIEW_SIQUALIFI_CONFIRMATIONLETTER',
  'PUBLISHVIEW_SIQUALIFI_FOLLOWUPLETTER' = 'PUBLISHVIEW_SIQUALIFI_FOLLOWUPLETTER',
  'VIEW_TSDA_STARTUP_SUMMARY' = 'VIEW_TSDA_STARTUP_SUMMARY',
  'VIEW_TUDA_FEASIBILITY' = 'VIEW_TUDA_FEASIBILITY',
  'VIEW_TSDA_FEASIBILITY' = 'VIEW_TSDA_FEASIBILITY',

  // Conduct Permissions
  'VIEW_CONDUCT_MILESTONE_TRACKING' = 'VIEW_CONDUCT_MILESTONE_TRACKING',
  'VIEW_CONDUCT_SUMMARY' = 'VIEW_CONDUCT_SUMMARY',
  'VIEW_SUBJECT_TRACKING' = 'VIEW_SUBJECT_TRACKING',
  'VIEW_IMVCHECKLIST' = 'VIEW_IMVCHECKLIST',
  'VIEW_CONDUCT_SITE_DOCUMENTS' = 'VIEW_CONDUCT_SITE_DOCUMENTS',
  'UPDATE_IMVCHECKLIST' = 'UPDATE_IMVCHECKLIST',
  'VIEW_IMVREPORT' = 'VIEW_IMVREPORT',
  'UPDATE_IMVREPORT' = 'UPDATE_IMVREPORT',
  'VIEW_CONDUCT_DATAMONITORING' = 'VIEW_CONDUCT_DATAMONITORING',
  'VIEW_QUERIES_MILESTONE' = 'VIEW_QUERIES_MILESTONE',
  'RAISE_QUERY_MILESTONE' = 'RAISE_QUERY_MILESTONE',
  'RESPOND_QUERY_MILESTONE' = 'RESPOND_QUERY_MILESTONE',
  'RESPOND_STARTUP_QUERY_MILESTONE' = 'RESPOND_STARTUP_QUERY_MILESTONE',
  'DELETE_QUERY_MILESTONE' = 'DELETE_QUERY_MILESTONE',
  'UPDATE_RISK_SCORE' = 'UPDATE_RISK_SCORE',
  'VIEW_CONDUCTSTUDYLOGS' = 'VIEW_CONDUCTSTUDYLOGS',
  'UPDATE_SPONSOR_ISSUE' = 'UPDATE_SPONSOR_ISSUE',
  'DELETE_OTHERS_SPONSOR_ISSUE' = 'DELETE_OTHERS_SPONSOR_ISSUE',
  'UPDATE_OTHERS_SPONSOR_ISSUE' = 'UPDATE_OTHERS_SPONSOR_ISSUE',
  'VIEW_SPONSOR_ISSUE' = 'VIEW_SPONSOR_ISSUE',
  'UPDATE_SPONSOR_ISSUE_DECISION' = 'UPDATE_SPONSOR_ISSUE_DECISION',
  'UPDATE_SPONSOR_ISSUE_ACTION' = 'UPDATE_SPONSOR_ISSUE_ACTION',
  'VIEW_SPONSOR_PROTOCOLDEVIATION' = 'VIEW_SPONSOR_PROTOCOLDEVIATION',
  'VIEW_SITE_PROTOCOLDEVIATION' = 'VIEW_SITE_PROTOCOLDEVIATION',
  'UPDATE_SPONSOR_PROTOCOLDEVIATION' = 'UPDATE_SPONSOR_PROTOCOLDEVIATION',
  'UPDATE_SPONSOR_PROTOCOLDEVIATION_ACTION' = 'UPDATE_SPONSOR_PROTOCOLDEVIATION_ACTION',
  'UPDATE_SPONSOR_PROTOCOLDEVIATION_DECISION' = 'UPDATE_SPONSOR_PROTOCOLDEVIATION_DECISION',
  'UPDATE_OTHERS_SPONSOR_PROTOCOLDEVIATION' = 'UPDATE_OTHERS_SPONSOR_PROTOCOLDEVIATION',
  'DELETE_OTHERS_SPONSOR_PROTOCOLDEVIATION' = 'DELETE_OTHERS_SPONSOR_PROTOCOLDEVIATION',
  'UPDATE_SITE_PROTOCOLDEVIATION' = 'UPDATE_SITE_PROTOCOLDEVIATION',
  'UPDATE_SITE_PROTOCOLDEVIATION_ACTION' = 'UPDATE_SITE_PROTOCOLDEVIATION_ACTION',
  'UPDATE_SITE_PROTOCOLDEVIATION_DECISION' = 'UPDATE_SITE_PROTOCOLDEVIATION_DECISION',
  'UPDATE_SITE_SPONSOR_PROTOCOLDEVIATION' = 'UPDATE_OTHERS_SITE_PROTOCOLDEVIATION',
  'DELETE_SITE_SPONSOR_PROTOCOLDEVIATION' = 'DELETE_OTHERS_SITE_PROTOCOLDEVIATION',
  'VIEW_CONDUCT_STUDYREPORTS' = 'VIEW_CONDUCT_STUDYREPORTS',
  'VIEW_CONDUCT_TASKS' = 'VIEW_CONDUCT_TASKS',
  'RAISE_STARTUP_QUERY_MILESTONE' = 'RAISE_STARTUP_QUERY_MILESTONE',
  'VIEW_STARTUP_QUERIES_MILESTONE' = 'VIEW_STARTUP_QUERIES_MILESTONE',
  'RESPOND_QUERY_CRF' = 'RESPOND_QUERY_CRF',
  'PUBLISH_IMV_CONFIRMATIONLETTER' = 'PUBLISH_IMV_CONFIRMATIONLETTER',
  'UPDATE_IMV_CONFIRMATIONLETTER' = 'UPDATE_IMV_CONFIRMATIONLETTER',
  'PUBLISHVIEW_IMVCONFIRMATION_LETTER' = 'PUBLISHVIEW_IMVCONFIRMATION_LETTER',
  'PUBLISHVIEW_IMVFOLLOWUP_LETTER' = 'PUBLISHVIEW_IMVFOLLOWUP_LETTER',
  'RAISE_CRF_QUERY' = 'RAISE_CRF_QUERY',
  'VIEW_CRF_QUERIES' = 'VIEW_CRF_QUERIES',
  'APPROVE_SITEQUALIFI_FOLLOWUPLETTER' = 'APPROVE_SITEQUALIFI_FOLLOWUPLETTER',
  'PUBLISH_SITEQUALIFI_FOLLOWUPLETTER' = 'PUBLISH_SITEQUALIFI_FOLLOWUPLETTER',
  'UPLOAD_IMVREPORTDOCUMENT' = 'UPLOAD_IMVREPORTDOCUMENT',
  'DELETE_IMVREPORT_DOCUMENT' = 'DELETE_IMVREPORT_DOCUMENT',
  'UPDATE_SIGNATURE_IMVREPORT' = 'UPDATE_SIGNATURE_IMVREPORT',
  'REVIEW_CRF_SOURCE_DATA' = 'REVIEW_CRF_SOURCE_DATA',
  'PUBLISH_IMVCHECKLIST' = 'PUBLISH_IMVCHECKLIST',
  'VIEW_SITEQUALIFI_CONFIRMATIONLETTER' = 'VIEW_SITEQUALIFI_CONFIRMATIONLETTER',
  'UPDATE_SITEQUALIFI_CONFIRMATIONLETTER' = 'UPDATE_SITEQUALIFI_CONFIRMATIONLETTER',
  'APPROVE_SITEQUALIFI_CONFIRMATIONLETTER' = 'APPROVE_SITEQUALIFI_CONFIRMATIONLETTER',
  'PUBLISH_SITEQUALIFI_CONFIRMATIONLETTER' = 'PUBLISH_SITEQUALIFI_CONFIRMATIONLETTER',
  'VIEW_SITEQUALIFI_FOLLOWUPLETTER' = 'VIEW_SITEQUALIFI_FOLLOWUPLETTER',
  'UPDATE_SITEQUALIFI_FOLLOWUPLETTER' = 'UPDATE_SITEQUALIFI_FOLLOWUPLETTER',
  'VIEW_IMV_CONFIRMATIONLETTER' = 'VIEW_IMV_CONFIRMATIONLETTER',
  'UPDATE_IMV_FOLLOWUPLETTER' = 'UPDATE_IMV_FOLLOWUPLETTER',
  'VIEW_IMV_FOLLOWUPLETTER' = 'VIEW_IMV_FOLLOWUPLETTER',
  'PUBLISH_IMV_FOLLOWUPLETTER' = 'PUBLISH_IMV_FOLLOWUPLETTER',
  'VIEW_SITEINITIATION_CONFIRMATIONLETTER' = 'VIEW_SITEINITIATION_CONFIRMATIONLETTER',
  'UPDATE_SITEINITIATION_CONFIRMATIONLETTER' = 'UPDATE_SITEINITIATION_CONFIRMATIONLETTER',
  'VIEW_SITEINITIATION_FOLLOWUPLETTER' = 'VIEW_SITEINITIATION_FOLLOWUPLETTER',
  'UPDATE_SITEINITIATION_FOLLOWUPLETTER' = 'UPDATE_SITEINITIATION_FOLLOWUPLETTER',
  'VIEW_CLINICAL_TRIAL_DATA_REVIEW' = 'VIEW_CLINICAL_TRIAL_DATA_REVIEW',
  //Closeout Permissions
  'VIEW_CLOSEOUT_SUMMARY' = 'VIEW_CLOSEOUT_SUMMARY',
  'VIEW_CLOSEOUT_COVCHECKLIST' = 'VIEW_CLOSEOUT_COVCHECKLIST',
  'VIEW_CLOSEOUT_COVREPORT' = 'VIEW_CLOSEOUT_COVREPORT',
  'VIEW_CLOSEOUT_ESSENTIALDOCUMENTS' = 'VIEW_CLOSEOUT_ESSENTIALDOCUMENTS',
  'VIEW_CLOSEOUT_STUDYLOGS' = 'VIEW_CLOSEOUT_STUDYLOGS',

  // New Conduct Permissions
  'VIEW_TRIALELIGIBLE_PATIENTS' = 'VIEW_TRIALELIGIBLE_PATIENTS',
  'VIEW_PATIENT_TRIAL_NOTEBOOK' = 'VIEW_PATIENT_TRIAL_NOTEBOOK',

  'VIEW_MONITORING_VISITS_SPONSOR' = 'VIEW_MONITORING_VISITS_SPONSOR',
  'VIEW_MONITORING_VISITS_SITE' = 'VIEW_MONITORING_VISITS_SITE',
  'VIEW_DRUG_SUPPLY' = 'VIEW_DRUG_SUPPLY',
  'VIEW_PENDING_SHIPMENTS' = 'VIEW_PENDING_SHIPMENTS',
  'VIEW_SUBJECT_VISITS_CALENDAR_SITE' = 'VIEW_SUBJECT_VISITS_CALENDAR_SITE',
  'VIEW_SUBJECT_VISITS_CALENDAR_SPONSOR'='VIEW_SUBJECT_VISITS_CALENDAR_SPONSOR'
}

export interface IAccess {
  account: string;
  'ctms-ui': string;
}

export enum AccessRoles {
  'manage-account' = 'manage-account',
  'view-applications' = 'view-applications',
  'view-consent' = 'view-consent',
  'manage-account-links' = 'manage-account-links',
  'manage-consent' = 'manage-consent',
  'delete-account' = 'delete-account',
  'view-profile' = 'view-profile'
}

export type KeycloakResourceAccess = {
  [key in keyof IAccess]: KeycloakRoles;
};

export interface KeycloakRoles {
  roles?: Array<AccessRoles>;
}

export interface IAPI {
  'ctms-api': {
    roles?: Array<CTMSAPI>;
  };
}

export interface IUI {
  'ctms-ui': {
    roles?: Array<CTMSUI>;
  };
}

export interface IUserPreferences {
  default_app: string;
  language: string;
  date_format: string;
  id?: string;
}

export interface IPortalProperties {
  study_id: string;
}
export interface IUser {
  email_verified: boolean;
  family_name: string;
  given_name: string;
  name: string;
  firstName?: string;
  lastName?: string;
  preferred_username: string;
  preferences?: IUserPreferences;
  portal_props?: any;
  resourceAccess?: IAPI & IUI;
  realmAccess: KeycloakRoles;
  token: string;
  // refreshToken: string;
  sessionId: string;
  loggedInTime: string;
  roles: any;
  email: string;
  sponsor: string;
  siteToken: string;
  sponsorToken: string;
  sponsor_sponsor_name: string;
  username: string;
}
